import { useToastController } from "@tamagui/toast";
import { AlertCircle, CheckCircle2, Info } from "lucide-react";
import { Token, getTokenValue } from "tamagui";

export function useShowToast() {
  const toast = useToastController();
  const successIconColor = getTokenValue("$successGreen" as Token, "color");
  const errorIconColor = getTokenValue("$warningRed" as Token, "color");
  const infoIconColor = getTokenValue("$hgPrimary" as Token, "color");

  const showSuccessToast = (title: string) => {
    toast.show(title, {
      icon: <CheckCircle2 color={successIconColor} />,
      duration: 5000,
    });
  };

  const showErrorToast = (title: string) => {
    toast.show(title, {
      icon: <AlertCircle color={errorIconColor} />,
      duration: 5000,
    });
  };

  const showInfoToast = (title: string) => {
    toast.show(title, {
      icon: <Info color={infoIconColor} />,
      duration: 5000,
    });
  };

  return {
    showSuccessToast,
    showErrorToast,
    showInfoToast,
  };
}
